import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { addBanker, addBulkCities, addStateCities, getBank, getStateWiseCities, updateBanker, updateStateCities } from "../../../services/userMasterUser";

export default function StateBulkCitiesCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [stateCitiesList, setStateCitiesList] = useState([])
  const [input, setInput] = useState({
    state: state?.state || "",
    cities: state?.city ? [state.city] : [""], // 👈 array
    status: state?.status || true,
  });

  const handleCityChange = (value, index) => {
    const updatedCities = [...input.cities];
    updatedCities[index] = value;

    setInput({
      ...input,
      cities: updatedCities,
    });
  };


  const addCityField = () => {
    setInput({
      ...input,
      cities: [...input.cities, ""],
    });
  };

  const removeCityField = (index) => {
    const updatedCities = input.cities.filter((_, i) => i !== index);

    setInput({
      ...input,
      cities: updatedCities.length ? updatedCities : [""],
    });
  };

  useEffect(() => {

    const stateCitiesData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      cityIn: [],
      stateIn: []
    }

    getStateWiseCities(stateCitiesData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          // const stateList = Object.keys(Res).map((key) => ({
          //   key
          // }));

          const stateListArray = Object.keys(Res);

          const stateList = stateListArray.map((item) => ({
            label: item,
            value: item,
          }));
          
          setStateCitiesList(stateList)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));

    if (state) {
      setInput(prevState => ({
        ...prevState,
        status: state?.status,
      }));
    }
  }, [state]);

  const [errors, setErrors] = useState({
    state: "",
    city: ""
  });

  const [statusData, setStatusData] = useState([
    { label: "ACTIVE", value: true },
    { label: "INACTIVE", value: false }
  ]);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;

    if (!input.cities || input.cities.length === 0) {
      newErrors.city = "Please Enter At Least One City";
      isValid = false;
    } else if (input.cities.some((c) => !c.trim())) {
      newErrors.city = "City cannot be empty";
      isValid = false;
    } else {
      newErrors.city = "";
    }

    

    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
       
      const uniqueCities = [...new Set(input.cities.map(c => c.trim()))];

      const data = uniqueCities.map((city) => ({
        state: input.state,
        city,
        status: true,
      }));

      addBulkCities(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/stateCities/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/user-master/stateCities/list")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div>State Cities {state ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        State
                      </label>
                      <Dropdown 
                        style={{ width: "100%" }}
                        value={input.state} 
                        onChange={(e) => setInput({
                          ...input,
                          state: e.value,
                        })} 
                        options={stateCitiesList} 
                        optionLabel="label" 
                        placeholder="Select a State"
                        filter 
                        filterDelay={400} 
                        required
                        disabled={input.cities.length > 1 ? true : false }
                        />
                      <div className="text-danger">{errors.state}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="city" className="form-label">
                        City
                      </label>
                      {input.cities.map((city, index) => (
                        <div key={index} className="flex mb-2" style={{ gap: "10px" }}>
                          <InputText
                            style={{ width: "100%" }}
                            value={city}
                            onChange={(e) => handleCityChange(e.target.value, index)}
                            placeholder={`Enter City ${index + 1}`}
                          />

                          {/* Remove button */}
                          {input.cities.length > 1 && (
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => removeCityField(index)}
                            >
                              ✕
                            </button>
                          )}
                        </div>
                      ))}

                      {/* Add More Button */}
                      <button
                        type="button"
                        className="btn btn-primary mt-2"
                        onClick={addCityField}
                      >
                        + Add More
                      </button>

                      <div className="text-danger">{errors.city}</div>
                    </div>
                  </div>
                  {state?.id && <div className="row mb-1">
                    <div className="col-md-12">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={statusData}
                        value={input.status}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            status: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>
                  </div>}
                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
